module.exports = __webpack_public_path__ + "static/912-f9115d77f3cad94f3624ed0ed25de5b0.png";